import React from 'react'

function Cross() {
  return (
   <>
   <svg 
   xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.32 35.32"
     id="closed"
     style={{
      height:"1rem",
      position:"absolute",
     }}>
  <g>
    <g>
      <path d="M20.76,17.66l2.93-2.93a1.89,1.89,0,0,0,0-2.66l-.44-.44a1.89,1.89,0,0,0-2.66,0l-2.93,2.93-2.93-2.93a1.89,1.89,0,0,0-2.66,0l-.44.44a1.89,1.89,0,0,0,0,2.66l2.93,2.93-2.93,2.93a1.89,1.89,0,0,0,0,2.66l.44.44a1.89,1.89,0,0,0,2.66,0l2.93-2.93,2.93,2.93a1.89,1.89,0,0,0,2.66,0l.44-.44a1.89,1.89,0,0,0,0-2.66Z"></path>
      <path d="M17.66,4.25A13.41,13.41,0,1,1,4.25,17.66,13.42,13.42,0,0,1,17.66,4.25m0-4.25A17.66,17.66,0,1,0,35.32,17.66,17.66,17.66,0,0,0,17.66,0Z"></path>
    </g>
  </g>
</svg>
   </>
  )
}

export default Cross